/**
 * DetailHero component.
 */
import ActionsContainer from '@components/atoms/container/detailHeroActionsContainer';
import Buttons from '@components/elements/detail/detailButtons';
import ChannelLogo from '@components/atoms/images/detailChannelLogo';
import Context from '@shared/components/utils/context/detailContext';
import HeroContainer from '@components/atoms/container/detailHeroContainer';
import Poster from '@components/atoms/images/detailPoster';
import SideContainer from '@components/atoms/container/detailHeroSideContainer';
import UpgradablePlan from '@components/elements/plan/upgradablePlan';
import { useContext } from 'react';

/**
 * Poster, channel logo, primary actions, and upgradable plan row.
 * A Hero section contains artwork and buttons.
 */
export default function DetailHero() {
  const { metadata } = useContext(Context);
  const { upgradablePlan, channelLogo, poster } = metadata || {};
  return (
    <HeroContainer id='detailHero'>
      <Poster src={poster} />
      <SideContainer>
        <ChannelLogo src={channelLogo || ''} />
        <ActionsContainer>
          <Buttons />
          {upgradablePlan ? <UpgradablePlan plan={upgradablePlan} /> : null}
        </ActionsContainer>
      </SideContainer>
    </HeroContainer>
  );
}
